import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { ConfigurationAreaService } from '../../../configuration-area.service';
import { ConfigurationEmailJobsService } from '../../configuration-email-jobs.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'configuration-email-jobs-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './email-jobs-view.part.html',
})

export class ConfigurationEmailJobsViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly pageService = inject(ConfigurationEmailJobsService);
	private readonly areaService = inject(ConfigurationAreaService);
	public setup = getSetup(this.util, this.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public emailJobs = computed(() => (this.areaService.configurationData()?.emailJobs ?? []).map(j => ({ ...j, updatedUTC: j.createdUTC })));

}